/* HPM – lecture muette uniquement quand le media est visible dans la page et dans son carrousel. */
(() => {
 'use strict';
 if (window.HPMVisibleVideoPlayback) {
   window.HPMVisibleVideoPlayback.scan(document);
   return;
 }
 const selector = 'video.hpm-visible-autoplay-video';
 const records = new Map();
 const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
 const supported = 'IntersectionObserver' in window;
 let observer = null;

 function updateButton(video) {
   const record = records.get(video);
   if (!record) return;
   const paused = video.paused;
   record.button.dataset.paused = String(paused);
   record.button.setAttribute('aria-label', paused ? 'Lire la vidéo sans son' : 'Mettre la vidéo en pause');
   record.button.title = paused ? 'Lire' : 'Pause';
 }

 function pause(video) {
   if (!video.paused) video.pause();
   updateButton(video);
 }

 function play(video) {
   video.muted = true;
   const result = video.play();
   if (result && typeof result.then === 'function') {
     result.then(() => updateButton(video)).catch(() => updateButton(video));
   } else {
     updateButton(video);
   }
 }

 function refresh(video) {
   const record = records.get(video);
   if (!record) return;
   if (!record.visible || document.hidden) {
     pause(video);
     return;
   }
   if (record.userPaused || reducedMotion.matches) {
     pause(video);
     return;
   }
   if (video.paused) play(video);
 }

 if (supported) {
   observer = new IntersectionObserver((entries) => {
     for (const entry of entries) {
       const record = records.get(entry.target);
       if (!record) continue;
       record.visible = entry.isIntersecting && entry.intersectionRatio >= 0.55;
       refresh(entry.target);
     }
   }, { threshold: [0, 0.55, 1] });
 }

 function activate(video) {
   if (records.has(video) || !supported) return;
   const wrapper = video.parentElement;
   if (!wrapper) return;
   const button = document.createElement('button');
   button.type = 'button';
   button.className = 'hpm-visible-video-toggle';
   button.dataset.paused = 'true';
   button.setAttribute('aria-label', 'Lire la vidéo sans son');
   button.title = 'Lire';
   video.controls = false;
   video.removeAttribute('controls');
   video.muted = true;
   video.defaultMuted = true;
   video.setAttribute('muted','');
   video.playsInline = true;
   video.loop = true;
   video.preload = 'metadata';
   video.setAttribute('aria-label', 'Vidéo WILIDI sans son');
   wrapper.appendChild(button);
   records.set(video, { button, visible:false, userPaused:false });
   const toggle = () => {
     const record = records.get(video);
     if (!record) return;
     if (video.paused) {
       record.userPaused = false;
       if (!document.hidden) play(video);
     } else {
       record.userPaused = true;
       pause(video);
     }
   };
   button.addEventListener('click', toggle);
   video.addEventListener('click', toggle);
   video.addEventListener('play', () => updateButton(video));
   video.addEventListener('pause', () => updateButton(video));
   observer.observe(video);
 }

 function scan(root = document) {
   if (root.matches && root.matches(selector)) activate(root);
   root.querySelectorAll?.(selector).forEach(activate);
   for (const [video] of records) {
     if (!video.isConnected) {
       observer?.unobserve(video);
       records.delete(video);
     }
   }
 }

 window.HPMVisibleVideoPlayback = { scan };
 document.addEventListener('shopify:section:load', (event) => scan(event.target));
 document.addEventListener('shopify:section:unload', () => {
   for (const [video] of records) {
     if (!video.isConnected) {
       observer?.unobserve(video);
       records.delete(video);
     }
   }
 });
 document.addEventListener('visibilitychange', () => {
   for (const [video] of records) refresh(video);
 });
 reducedMotion.addEventListener?.('change', () => {
   for (const [video] of records) refresh(video);
 });
 scan(document);
})();
